import { useEffect, memo } from 'react';

/**
 * Critical resource preloader component
 * Preloads critical resources for better performance
 */
const CriticalResourcePreloader = memo(() => {
  useEffect(() => {
    // Preload critical images and resources
    const criticalResources = [
      // Add any critical images or resources here
      // '/hero-image.webp',
      // '/logo.svg',
    ];

    const preloadResource = (href: string, as: string = 'image') => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = href;
      link.as = as;
      document.head.appendChild(link);
    };

    criticalResources.forEach(resource => {
      preloadResource(resource, 'image');
    });

    // Preload next page resources on idle
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        // Preload likely next pages
        const nextPageResources = [
          '/contact',
          '/about',
          '/blog'
        ];

        nextPageResources.forEach(path => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = path;
          document.head.appendChild(link);
        });
      });
    }
  }, []);

  return null;
});

CriticalResourcePreloader.displayName = 'CriticalResourcePreloader';

export default CriticalResourcePreloader;